/**
 * Created by gaupoit on 29/3/17.
 */

import { ACTIONS } from '../actions';

const INITIAL_STATE = {
	isError: false,
	url: ''
};

export default function (state = INITIAL_STATE, action) {
	switch (action.type) {
		case ACTIONS.SYNC_TO_S3:
		    if(action.payload.status === 200) {
				return { ...state, url: action.payload.data, isError: false };
			} else {
				return { ...state, message: action.payload.response.data.message, isError: true };
			}
		default:
			return state;
	}
}